import { CSSObject } from '@chakra-ui/react';

export const StartTime: CSSObject = {
  fontSize: '2xs',
  fontWeight: 'medium',
  px: '1',
  py: '0.5',
  borderRadius: 'base',
  bg: 'blackAlpha.500',
  color: 'white',
};
